import createMuiTheme from '@material-ui/core/styles/createMuiTheme'

export const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#00ff00',
            main: '#222831',
            dark: '#393e46',
            contrastText: '#fff'
        },
        secondary: {
            light: '#00ff00',
            main: '#f2f2f2',
            dark: '#222831',
            contrastText: '#9e9e9e'
        },
        type: 'light'
    }
})